var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	39818: {
		fallback: function() { return __webpack_require__.e(6313).then(function() { return function() { return __webpack_require__(6313); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx/style",
	},
	67219: {
		fallback: function() { return __webpack_require__.e(1041).then(function() { return function() { return __webpack_require__(91041); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/head",
	},
	5170: {
		fallback: function() { return Promise.all([__webpack_require__.e(9807), __webpack_require__.e(4134), __webpack_require__.e(5610), __webpack_require__.e(8766)]).then(function() { return function() { return __webpack_require__(5610); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/router",
	},
	79415: {
		fallback: function() { return Promise.all([__webpack_require__.e(9807), __webpack_require__.e(4539)]).then(function() { return function() { return __webpack_require__(84539); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/link",
	},
	21305: {
		fallback: function() { return Promise.all([__webpack_require__.e(4134), __webpack_require__.e(8766), __webpack_require__.e(8958)]).then(function() { return function() { return __webpack_require__(90356); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/script",
	},
	56991: {
		fallback: function() { return Promise.all([__webpack_require__.e(4922), __webpack_require__.e(8766)]).then(function() { return function() { return __webpack_require__(4922); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/image",
	},
	20795: {
		fallback: function() { return __webpack_require__.e(3878).then(function() { return function() { return __webpack_require__(13878); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/dynamic",
	},
	56549: {
		fallback: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(13274); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react/jsx-runtime",
	},
	668: {
		fallback: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(79474); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",
	},
	71383: {
		fallback: function() { return __webpack_require__.e(7224).then(function() { return function() { return __webpack_require__(77224); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx",
	},
	68153: {
		fallback: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(48088); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom/client",
	},
	28766: {
		fallback: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(41615); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",
	},
	66025: {
		fallback: function() { return __webpack_require__.e(8495).then(function() { return function() { return __webpack_require__(13733); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.11.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@emotion/react",
	},
	97478: {
		fallback: function() { return __webpack_require__.e(8495).then(function() { return function() { return __webpack_require__(13733); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.9.3",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@emotion/react",
	},
	6140: {
		fallback: function() { return __webpack_require__.e(2698).then(function() { return function() { return __webpack_require__(52698); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "6.0.22",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@mantine/hooks",
	},
	95791: {
		fallback: function() { return Promise.all([__webpack_require__.e(8933), __webpack_require__.e(1294), __webpack_require__.e(1778)]).then(function() { return function() { return __webpack_require__(31294); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "6.0.22",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@mantine/core",
	},
	6062: {
		fallback: function() { return Promise.all([__webpack_require__.e(8933), __webpack_require__.e(1294), __webpack_require__.e(6140), __webpack_require__.e(1778)]).then(function() { return function() { return __webpack_require__(31294); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~6.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@mantine/core",
	},
	52041: {
		fallback: function() { return __webpack_require__.e(2698).then(function() { return function() { return __webpack_require__(52698); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~6.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@mantine/hooks",
	},
	11778: {
		fallback: function() { return __webpack_require__.e(6114).then(function() { return function() { return __webpack_require__(13733); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=11.9.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@emotion/react",
	},
	43526: {
		fallback: function() { return __webpack_require__.e(8495).then(function() { return function() { return __webpack_require__(13733); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.11.4",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@emotion/react",
	},
	26174: {
		fallback: function() { return Promise.all([__webpack_require__.e(3290), __webpack_require__.e(1432), __webpack_require__.e(6025), __webpack_require__.e(7478), __webpack_require__.e(6140), __webpack_require__.e(5791), __webpack_require__.e(8868)]).then(function() { return function() { return __webpack_require__(51432); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=3.13.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@inflearn/ds-react",
	},
	25609: {
		fallback: function() { return __webpack_require__.e(8495).then(function() { return function() { return __webpack_require__(13733); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.13.3",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@emotion/react",
	},
	68941: {
		fallback: function() { return __webpack_require__.e(2698).then(function() { return function() { return __webpack_require__(52698); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~6.0.22",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@mantine/hooks",
	},
	2824: {
		fallback: function() { return Promise.all([__webpack_require__.e(3290), __webpack_require__.e(1432), __webpack_require__.e(6025), __webpack_require__.e(7478), __webpack_require__.e(6140), __webpack_require__.e(5791), __webpack_require__.e(8868)]).then(function() { return function() { return __webpack_require__(51432); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.14.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@inflearn/ds-react",
	},
	56497: {
		fallback: function() { return __webpack_require__.e(4459).then(function() { return function() { return __webpack_require__(94459); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.45.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@hackler/react-sdk",
	},
	4411: {
		fallback: function() { return __webpack_require__.e(3878).then(function() { return function() { return __webpack_require__(13878); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "14.2.35",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/dynamic",
	},
	34681: {
		fallback: function() { return Promise.all([__webpack_require__.e(3290), __webpack_require__.e(1432), __webpack_require__.e(6025), __webpack_require__.e(7478), __webpack_require__.e(6140), __webpack_require__.e(5791), __webpack_require__.e(8868)]).then(function() { return function() { return __webpack_require__(51432); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.4.4",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@inflearn/ds-react",
	},
	9225: {
		fallback: function() { return __webpack_require__.e(1041).then(function() { return function() { return __webpack_require__(91041); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "14.2.35",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/head",
	},
	99046: {
		fallback: function() { return Promise.all([__webpack_require__.e(8933), __webpack_require__.e(1294), __webpack_require__.e(6140), __webpack_require__.e(1778)]).then(function() { return function() { return __webpack_require__(31294); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~6.0.22",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@mantine/core",
	},
	88225: {
		fallback: function() { return Promise.all([__webpack_require__.e(3290), __webpack_require__.e(1432), __webpack_require__.e(7478), __webpack_require__.e(6140), __webpack_require__.e(5791)]).then(function() { return function() { return __webpack_require__(51432); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.7.10",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@inflearn/ds-react",
	},
	97997: {
		fallback: function() { return __webpack_require__.e(6920).then(function() { return function() { return __webpack_require__(84539); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "14.2.35",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/link",
	},
	26361: {
		fallback: function() { return Promise.all([__webpack_require__.e(3290), __webpack_require__.e(1432), __webpack_require__.e(7478), __webpack_require__.e(6140), __webpack_require__.e(5791)]).then(function() { return function() { return __webpack_require__(51432); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@inflearn/ds-react",
	},
	1057: {
		fallback: function() { return __webpack_require__.e(356).then(function() { return function() { return __webpack_require__(90356); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "14.2.35",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/script",
	},
	16187: {
		fallback: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(49906); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom/server",
	},
	19396: {
		fallback: function() { return Promise.all([__webpack_require__.e(3290), __webpack_require__.e(1432)]).then(function() { return function() { return __webpack_require__(51432); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.7.4",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@inflearn/ds-react",
	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [39818,67219,5170,79415,21305,56991,20795,56549,668,71383,56549,668,68153,28766,43526,26174,25609,6062,52041,5170,68941,2824,56497,4411,97478,34681,9225,66025,99046,88225,97997,26361,6140,95791,1057];
__webpack_require__.federation.installInitialConsumes = function() { return __webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}); }
__webpack_require__.consumesLoadingData.chunkMapping = {
	"636": [
		43526,
		26174,
		25609,
		6062,
		52041,
		5170,
		68941,
		2824,
		56497,
		4411
	],
	"1057": [
		1057
	],
	"1778": [
		11778
	],
	"3050": [
		19396
	],
	"4681": [
		34681
	],
	"5303": [
		6062,
		52041
	],
	"5527": [
		67219,
		5170,
		79415,
		21305,
		56991,
		20795,
		56549,
		668,
		71383
	],
	"5791": [
		95791
	],
	"5954": [
		9225
	],
	"6025": [
		66025
	],
	"6140": [
		6140
	],
	"6187": [
		16187
	],
	"6361": [
		26361
	],
	"7478": [
		97478
	],
	"7997": [
		97997
	],
	"8225": [
		88225
	],
	"8766": [
		28766
	],
	"8792": [
		56549,
		668,
		68153,
		28766
	],
	"9046": [
		99046
	],
	"9818": [
		39818
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}